"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store = require("store2");
var storetypes_1 = require("./storetypes");
var HIVER_CONFIG_PREFIX = 'hiver-config';
var SELECTED_STORE = {
    name: storetypes_1.StoreTypes.LOCAL,
    get type() {
        return this.name;
    },
    set type(storeType) {
        if (Object.values(storetypes_1.StoreTypes).includes(storeType)) {
            this.name = storeType;
        }
    }
};
exports.SELECTED_STORE = SELECTED_STORE;
var HIVER_CONFIG_STORE = function () {
    return SELECTED_STORE.type === 'session'
        ? store.session.namespace(HIVER_CONFIG_PREFIX)
        : store.local.namespace(HIVER_CONFIG_PREFIX);
};
exports.HIVER_CONFIG_STORE = HIVER_CONFIG_STORE;
//# sourceMappingURL=store-setup.js.map